<script>
import Table from "@/components/table-v.vue";
import FormModal from "@/components/form-modal.vue";
import { mapGetters } from "vuex";
import { AnyAdmin } from "@/core/enums/user-types";
import { TiposResponsaveisEnum } from "../../responsaveis/responsaveis.types";

export default {
  components: {
    FormModal,
    Table
  },
  props: {
    typeId: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      loading: false,
      rows: [],
      formDialog: {
        opened: false,
        data: {},
        editing: false
      }
    };
  },
  computed: {
    ...mapGetters(["clientId", "user"]),
    hasAdminRole() {
      return this.user.nivel_hierarquico?.tipo_id === TiposResponsaveisEnum.ADMINISTRADOR;
    },
    canManage() {
      return this.hasAdminRole || AnyAdmin.includes(this.user.tipo_usuario);
    },
    actionBarButtons() {
      const buttons = [
        {
          text: "Atualizar",
          icon: "mdi-refresh",
          action: () => {
            this.doLoad();
          }
        }
      ];

      if (this.canManage) {
        buttons.push({
          text: "Adicionar",
          icon: "mdi-plus-box-outline",
          action: () => {
            this.formDialog.editing = false;
            this.formDialog.data = {};
            this.formDialog.opened = true;
          }
        });
      }

      return buttons;
    },
    cols() {
      return [
        {
          key: "nome",
          name: "Nome",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        }
      ];
    },
    customResource() {
      const resource = this.apiResource(`v1/ativacaoped/${this.clientId}/configuracoes`);
      const typeId = this.typeId;

      return {
        ...resource,
        async get(params) {
          try {
            let id = undefined;
            let query = "";

            if (!isNaN(params)) {
              id = params;
            } else {
              if ('id' in params) {
                id = params.id;
              }

              if ('query' in params) {
                query = params.query;
              }
            }

            if (!query.includes('tipo=')) {
              if (query.length > 0) {
                query += '&';
              }

              query += `tipo=${typeId}`;
            }

            const response = await resource.get({ id, query });
            return response.data;
          } catch (error) {
            return Promise.reject(error);
          }
        },
        async save(data, id) {
          try {
            const body = {
              ...data,
              tipo_id: typeId
            };
            const response = await resource.save(body, id);
            return response.data;
          } catch (error) {
            return Promise.reject(error);
          }
        }
      };
    }
  },
  async created() {
    await this.doLoad();
  },
  methods: {
    async doLoad() {
      this.loading = true;

      try {
        const result = await this.customResource.get({ query: "" });
        this.rows = Array.isArray(result) ? result : [];
      } catch (error) {
        this.rows = [];

        if (!error.isAxiosError) {
          this.notify(error);
        }
      } finally {
        this.loading = false;
      }
    },
    contextmenu(row, event, _, col) {
      if (!this.canManage) {
        return;
      }

      setTimeout(() => {
        const menu = [
          {
            name: "Editar",
            icon:
              "v-icon notranslate mr-3 mdi mdi-square-edit-outline theme--light",
            cb: (row) => {
              this.openEdit(row);
            }
          }
        ];

        this.showContext({
          left: event.clientX,
          top: event.clientY,
          val: row,
          col,
          menu
        });
      }, 100);
    },
    openEdit(row) {
      this.formDialog.editing = true;
      this.formDialog.data = { ...row };
      this.formDialog.opened = true;
    },
    async doSave(data) {
      const invalid = this.cols.some(({ valid }) => !valid || !valid());

      if (invalid) {
        return;
      }

      try {
        const id = this.formDialog.editing ? data.id : undefined;
        await this.customResource.save(data, id);

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: this.formDialog.editing ? "Edição concluída" : "Cadastro concluído",
          text: this.formDialog.editing ? "Registro atualizado com sucesso." : "Registro criado com sucesso."
        });

        this.formDialog.opened = false;
        this.formDialog.data = {};
        await this.doLoad();
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    }
  }
};
</script>

<template>
  <v-card :color="tableColor" elevation="0">
    <Table
      :actionBarButtons="actionBarButtons"
      :cols="cols"
      disablePagination
      :hasExportCSV="false"
      :hasFilter="false"
      :hasExportXLSX="false"
      :loading="loading"
      :rows="rows"
      @contextmenu="contextmenu"
    />

    <FormModal
      :cols="cols"
      :opened.sync="formDialog.opened"
      :title="formDialog.editing ? 'Editar opção' : 'Adicionar opção'"
      :value.sync="formDialog.data"
      @save="doSave"
    />
  </v-card>
</template>
